module.exports = __webpack_public_path__ + "static/media/follow-react.1b353fbb.svg";